import { RefundDTO } from '../modules/refunds/types';
import { Api } from './Api';

export class RefundsApi {
  static async getRefunds() {
    return await Api.get('/orders/api/v1/refunds');
  }

  static async createRefund(data: Partial<RefundDTO>) {
    return await Api.post('/orders/api/v1/refunds', data);
  }

  static async retrieveRefund(id: string) {
    return await Api.get(`/orders/api/v1/refunds/${id}`);
  }

  static async uploadAttachments(id: string, files: File[]) {
    const formData = new FormData();
    files.forEach(file => formData.append('files', file));
    return await Api.post(`/orders/api/v1/refunds/${id}/upload_attachments`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }
}
